<template>
  <div v-if="!loading" class="card card-body p-0 border-top border-top-1 border-gray-200 mb-5">
    <div class="table-responsive custom-table analytics-table p-1">
      <table class="table table-rounded fs-7 table-row-gray-300 gy-2 custom-table align-middle mb-0 w-full border-collapse">
        <thead>
        <tr class="fw-bold fs-6 text-gray-800">
          <th class="border-r border-dashed min-w-125px">Дата</th>
          <th v-for="item in realizationData" :key="'h-' + item.date" class="border-r border-dashed text-end min-w-125px">
            {{ item.date }}
          </th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td class="border-r border-dashed fw-bold">Количество</td>
          <td v-for="item in realizationData" :key="'c-' + item.date" class="border-r border-dashed text-end min-w-125px">
            {{ item.count }}
          </td>
        </tr>
        <tr>
          <td class="border-r border-dashed fw-bold">Сумма</td>
          <td v-for="item in realizationData" :key="'t-' + item.date" class="border-r border-dashed text-end min-w-125px">
            {{ item.totalAmount ? item.totalAmount.toLocaleString('ru-RU') + ' сум.' : '' }}
          </td>
        </tr>
        <tr>
          <td class="border-r border-dashed fw-bold">Реализация</td>
          <td v-for="item in realizationData" :key="'v-' + item.date" class="border-r border-dashed text-end min-w-125px">
            {{ item.volume }} кВт•ч
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div v-if="!loading" class="bg-body rounded p-5 mb-5">
    <div class="row">
      <div class="col-lg-6 mb-5 mb-lg-0">
        <h4 class="align-items-start flex-column fw-bold text-gray-900 mb-0 ms-lg-4 mt-2">
          {{ this.$route.meta.title || 'Страница' }} <span class="text-muted fw-normal fs-6">Сегодня</span>
          <span class="d-block mt-2 text-muted fs-8"> Показано {{ page * size + 1 }}–{{ Math.min((page + 1) * size, totalElements) }} из {{ totalElements }}</span>
        </h4>
      </div>
      <div class="col-lg-6 text-end">
        <div class="card-toolbar d-flex justify-content-end">
          <select-field
            v-model="size"
            id="pageSize"
            name="pageSize"
            :options="{15:'15', 25:'25', 50:'50'}"
            placeholder="Количество записи"
            class="w-100 w-lg-225px"
          />
          <div @click="showFilter = !showFilter" class="btn btn-icon btn-light ms-2 w-50px h-50px">
            <i v-if="!showFilter" class="ki-duotone ki-filter fs-3">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
            <i v-else class="ki-duotone ki-cross fs-1">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
          </div>
        </div>
      </div>
    </div>
  </div>
  <orders-filter v-if="statuses && showFilter" :statuses="statuses" @search="search"/>
  <div v-if="!loading" class="card card-body p-0 border-top border-top-1 border-gray-200">
    <div class="table-responsive custom-table">
      <table class="table table-hover table-rounded table-striped table-row-dashed fs-7 table-row-gray-300 gy-5 custom-table align-middle mb-0">
        <thead>
        <tr class="fw-bold fs-8 text-gray-400">
          <th>ID</th>
          <th>Коннектор - №</th>
          <th>Статус</th>
          <th>Сумма</th>
          <th>Фактический объём</th>
          <th>Наименование</th>
          <th>Мощность</th>
          <th>Информация о счетах</th>
          <th class="text-end">Время создания</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, key) in orders" @click="openItemModal(key)" class="cursor-pointer">
          <td>{{ item.orderNum }}</td>
          <td>{{ item?.spec?.details?.activeConnector?.label }} - {{item?.spec?.details?.activeConnector?.position}}</td>
          <td><span class="px-3 py-1 rounded text-white fs-9 fw-bold text-lowercase text-nowrap" :class="statusColor[item.status.status]">{{ getDescrByCode(item.status.status) }}</span></td>
          <td><span class="text-nowrap">{{ formatFullAmount(item.totalAmount) }} сум.</span></td>
          <td>{{ item.volume }}</td>
          <td><span class="text-nowrap">{{ item?.spec?.details?.stationName }}</span></td>
          <td>{{ item?.spec?.details?.activeConnector?.power ? item?.spec?.details?.activeConnector?.power+' кВт•ч' : '' }}</td>
          <td>
            <div v-if="item?.contractsInfo?.types" class="d-flex flex-column gap-1">
              <div v-if="item.contractsInfo.types.account && hasNonZeroCurrencies(item.contractsInfo.types.account.currencies)" class="small">
                <strong>Основной счет:</strong>
                <span v-for="(currency, key) in getNonZeroCurrencies(item.contractsInfo.types.account.currencies)" :key="key" class="ms-1">
                  {{ formatCurrencyAmount(currency.amount, key) }}
                </span>
              </div>
              <div v-if="item.contractsInfo.types.ticket && hasNonZeroCurrencies(item.contractsInfo.types.ticket.currencies)" class="small">
                <strong>Абонемент:</strong>
                <span v-for="(currency, key) in getNonZeroCurrencies(item.contractsInfo.types.ticket.currencies)" :key="key" class="ms-1">
                  {{ formatCurrencyAmount(currency.amount, key) }}
                </span>
              </div>
            </div>
            <span v-else class="text-muted">—</span>
          </td>
          <td class="text-end">{{ this.getHumanDate(item.completedAt ?? item.createdAt) }}</td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="text-center border-top">
      <div class="btn-group p-5">
        <button class="btn btn-sm btn-light" :disabled="page === 0" @click="goToPage(page - 1)">
          <i class="ki-outline ki-arrow-left"></i>
        </button>

        <button
          v-for="(p, i) in visiblePages"
          :key="i"
          class="btn btn-sm btn-light"
          :class="{
              'text-gray-600': p !== '...' && page !== p,
              'text-success fw-bold': p !== '...' && page === p,
              'btn-disabled text-muted': p === '...'
            }"
          :disabled="p === '...'"
          @click="p !== '...' && goToPage(p)"
        >
          {{ p === '...' ? '...' : p + 1 }}
        </button>

        <button class="btn btn-sm btn-light" :disabled="page === totalPages - 1" @click="goToPage(page + 1)">
          <i class="ki-outline ki-arrow-right"></i>
        </button>
      </div>
    </div>
  </div>
  <div v-else class="card rounded">
    <loader />
  </div>
  <orders-modal :item="changed !== null ? orders[changed] : null"/>
</template>

<script>
// Components
import OrdersFilter from '@/components/OrdersFilter'
import OrdersModal from '@/views/Orders/OrdersModal'
import SelectField from '@/components/Fields/SelectField'
import Loader from '@/components/Loader'
// Other
import { notify } from '@kyvg/vue3-notification'
import moment from 'moment/moment'
import axios from 'axios'

export default {
  name: 'Orders',
  components: {OrdersFilter, OrdersModal, Loader, SelectField},
  data() {
    return {
      showFilter: false,
      loading: false,
      orders: [],
      stations: null,
      statuses: null,
      changed: null,
      page: 0,
      size: 15,
      totalPages: 0,
      totalElements: 0,
      realizationData: null,
      statusColor: {
        NEW: 'bg-info text-light-info',
        ESP_PLACED: 'bg-info text-light-info',
        ESP_CHARGING: 'bg-info text-light-info',
        FINISH: 'bg-success text-light-success',
        CANCELLED: 'bg-danger text-light-danger',
      },
      filter: {
        fromDate: null,
        toDate: null,
      }
    }
  },
  computed: {
    visiblePages() {
      const pages = [];
      const total = this.totalPages;
      const current = this.page;
      if (total <= 7) {
        for (let i = 0; i < total; i++) pages.push(i);
      } else {
        pages.push(0);
        if (current > 3) pages.push('...');
        const start = Math.max(1, current - 1);
        const end = Math.min(total - 2, current + 1);
        for (let i = start; i <= end; i++) {
          pages.push(i);
        }
        if (current < total - 4) pages.push('...');
        pages.push(total - 1);
      }
      return pages;
    }
  },
  mounted() {
    this.getStatusesDic()
    this.setDefault()
    this.getOrders()
    this.getEspRealization()
  },
  methods: {
    openItemModal (key) {
      this.changed = key
      setTimeout(() => {
        const modalEl = document.getElementById('orderItemModal');
        const modal = new bootstrap.Modal(modalEl);
        modal.show();
      }, 10);
    },
    getOrders(page = this.page) {
      this.loading = true;
      this.filter['page'] = page;
      axios.get('order-service/api/v1/admin/orders/esp', {
        params: this.filter,
        headers: {
          'accept': 'application/json;charset=UTF-8',
        }
      })
        .then(res => {
          if (res.data?.content?.length >= 0) {
            this.orders = res.data.content;
            this.totalPages = res.data.totalPages;
            this.totalElements = res.data.totalElements;
            this.page = res.data.number;
          } else {
            notify({
              duration: 7000,
              type: 'error',
              speed: 1000,
              title: 'Ошибка',
              text: 'Что-то пошло не так!',
            });
          }
        })
        .catch(error => {
          notify({
            duration: 7000,
            type: 'error',
            speed: 1000,
            title: 'Ошибка',
            text: error?.response?.data?.errorDescription ?? error.message,
          });
        })
        .finally(() => { this.loading = false; });
    },
    goToPage(newPage) {
      if (newPage >= 0 && newPage < this.totalPages) {
        this.filter.size = this.size
        this.page = newPage;
        this.getOrders(newPage);
      }
    },
    getStatusesDic() {
      axios.get('order-service/api/v1/admin/statuses/esp')
        .then(res => {
          if (res.data.length > 0) {
            this.statuses = res.data
          } else {
            notify({
              duration: 7000,
              type: 'error',
              speed: 1000,
              title: 'Ошибка',
              text: 'Что-то пошло не так!',
            });
          }
        })
        .catch(error => {
          console.error('Ошибка при выполнении запроса:', error);
        })
    },
    getHumanDate(date) {
      if (!date) return '';
      return moment(date).utcOffset(300).format('DD.MM.YYYY HH:mm:ss');
    },
    getDescrByCode(code) {
      if (!this.statuses) return code
      if (!code) return ''
      const found = this.statuses.find(item => item.code === code);
      return found ? found.descr : code;
    },
    getEspRealization() {
      const now = new Date();
      const fiveDaysAgo = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 6);
      const fromDate = fiveDaysAgo.getTime();
      const toDate = now.getTime();
      axios.get('order-service/api/v1/admin/realization/esp', {
        params: {fromDate: fromDate, toDate: toDate}
      })
        .then(res => {this.realizationData = res.data})
        .catch(err => {console.error('Ошибка при запросе getEspRealization:', err)})
    },
    search(search) {
      if (search) {
        this.filter.fromDate     = search.fromDate  ? this.toUnix(search.fromDate) : null
        this.filter.toDate       = search.toDate    ? this.toUnix(search.toDate, true) : null
        this.filter['status']    = search.status    ?? null
        this.filter['pointCode'] = search.pointCode ?? null
        if (search.userId) this.filter['userId'] = search.userId
      } else {
        this.setDefault()
      }
      this.getOrders(0)
    },
    setDefault() {
      const fromDate = new Date();
      fromDate.setHours(0, 0, 0, 0);
      this.filter.fromDate = fromDate.getTime();
      this.filter.toDate = Date.now();
      this.filter.size = this.size
      if (this.filter.hasOwnProperty('userId')) delete this.filter['userId'];
    },
    formatFullAmount(value) {
      const number = parseFloat(value);
      if (isNaN(number)) return '0.00';
      return new Intl.NumberFormat('ru-RU', {
        useGrouping: true,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        style: 'decimal'
      }).format(number);
    },
    toUnix(dateStr, isEnd = false) {
      const date = new Date(`${dateStr}T00:00:00+05:00`);
      if (isEnd) { date.setDate(date.getDate() + 1) }
      return date.getTime();
    },
    formatCurrencyAmount(amount, currencyType) {
      if (!amount || amount === 0) return '';
      const num = parseFloat(amount);
      if (isNaN(num)) return '';
      
      if (currencyType === 'kwh') {
        return `${num} кВт•ч`;
      } else if (currencyType === 'uzs') {
        return `${this.formatFullAmount(num)} сум.`;
      } else {
        return `${num} ${currencyType}`;
      }
    },
    hasNonZeroCurrencies(currencies) {
      if (!currencies) return false;
      return Object.values(currencies).some(currency => currency.amount && currency.amount > 0);
    },
    getNonZeroCurrencies(currencies) {
      if (!currencies) return {};
      const filtered = {};
      Object.keys(currencies).forEach(key => {
        if (currencies[key].amount && currencies[key].amount > 0) {
          filtered[key] = currencies[key];
        }
      });
      return filtered;
    },
  },
  watch: {
    size: {
      deep: true,
      handler(val) {
        if (val) {
          this.filter.size = val;
          this.goToPage(0)
        }
      }
    }
  }
}
</script>

<style scoped>
.analytics-table td,
.analytics-table th {
  border-right: 1px dashed #e6e9f0;
}
html[data-bs-theme="dark"] .analytics-table td,
html[data-bs-theme="dark"] .analytics-table th {
  border-right: 1px dashed #363843;
}
.analytics-table td:last-child,
.analytics-table th:last-child {
  border-right: none !important;
}
.analytics-table tr, .analytics-table th, .analytics-table td {
  padding: 0.30rem 1.25rem !important;
}
</style>